var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!(_vm.value===undefined || _vm.value===null))?_c('span',[_vm._v(" "+_vm._s(_vm.formatted(_vm.value))+" "),(_vm.unit)?_c('small',[_vm._v(_vm._s(_vm.unit))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }